import { forwardRef } from 'react';

import { ButtonLink, type ButtonLinkProps } from '@backstage/ui';

import { useConfidenceUrl } from '../../hooks';

export const ConfidenceWebsiteButtonLink = forwardRef<
  HTMLAnchorElement,
  Omit<ButtonLinkProps, 'href'> & { route?: string }
>(({ route = '', target = '_blank', ...props }, ref) => {
  const url = useConfidenceUrl(route);
  return <ButtonLink {...props} href={url.href} target={target} ref={ref} />;
});
